<template>
    <v-text-field
        append-icon="mdi-magnify"
        placeholder="Search..."
        v-model="searchInput"
        @keyup="handleInput"
        class="pb-0 mb-0"
        autofocus
        ref="inputsearch"     
    />
</template>

<script>
export default {
  data() {
    return {
      searchInput: '',
      trigger: undefined
    }
  },
  mounted(){
 
  },
  computed:{
    loading: {
      get(){
        return this.$store.getters.getResourcesLoading
      }
    }
  },
  methods:{
    handleInput(){
      if(this.trigger !== undefined){
        clearTimeout(this.trigger)
        this.trigger = undefined
      }
      this.trigger = setTimeout(()=>{
        this.$store.commit('setSearchQuery', this.searchInput)
        this.trigger= undefined
         
      },800)
    }
  }
}
</script>